import { FormattedMessage } from 'react-intl'
import { cn } from '../../lib/utils.ts'

export const Divider = ({ color }: { color?: string }) => {
  return <div className={cn('h-1 w-full', color ? color : 'bg-blue150')} />
}

export const DividerWithText = ({
  textClassName,
  wrapperClassName,
}: {
  textClassName?: string
  wrapperClassName?: string
}) => {
  return (
    <div
      className={cn(
        'mt-20 flex items-center justify-center gap-10',
        wrapperClassName,
      )}
    >
      <div className="h-1 grow bg-black-20"></div>
      <span className={cn('mx-8 text-black-20', textClassName)}>
        <FormattedMessage id="or" />
      </span>
      <div className="h-1 grow bg-black-20"></div>
    </div>
  )
}
